export const GOOGLE_DRIVE_RESTRICT_ERROR_TEXT =
  "Google drive url not supported";

export const GOOGLE_DRIVE_ENABLED = false; // this to restrict google drive video link, in future if it work then only this flag need to change to true
